export default "__VITE_ASSET__0b1e99c6__"